/* eslint-disable no-use-before-define */
/* eslint-disable max-statements */
import React, {
	useState,
	useEffect
} from 'react';
import PropTypes from 'prop-types';

import {
	runValidators
} from '../../Utils/validation';

export const Form = (props) => {
	const [values, setValues] = useState(props.initialValues);
	const [ownErrors, setOwnErrors] = useState({});
	const [errors, setErrors] = useState({});

	useEffect(() => {
		setValues({
			...props.initialValues,
			...values
		});
	}, [props.initialValues]);

	const onBlur = (fieldName) => {
		if (props.validateOnBlur) {
			validateField(fieldName);
		}
	};

	const updateValue = (value, fieldName) => {	
		if (!fieldName) {
			return;
		}

		setValues({
			...values,
			[fieldName]: value
		});

		if (props.validateOnChange) {
			validateField(fieldName, value);
		}
	}

	const onChange = (e) => {		
		if (!e) {
			return;
		}
		const fieldName = e.target.id;
		let value = null;


		if (e.target.type === 'checkbox') {
			value = e.target.checked;
		} else {
			value = e.target.value;
		}
		setValues({
			...values,
			[fieldName]: value
		});

		if (props.validateOnChange) {
			validateField(fieldName, value);
		}
	};

	const onError = (e) => {
		const fieldName = e.target.id;
		const error = e.target.error || null;

		setOwnErrors({
			...ownErrors,
			[fieldName]: error
		});
	};

	const resetErrors = (value) => {
		const fieldNames = Array.isArray(value) ? value : [value];
		const reset = {};

		for (const fieldName of fieldNames) {
			reset[fieldName] = null;
		}
		setErrors({
			...errors,
			...reset
		});
	};

	const validateForm = () => {		
		const newErrors = {};
		let validForm = true;

		Object.keys(props.validationSchema).forEach((fieldName) => {			
			const field = props.validationSchema[fieldName];

			if (field) {
				const error =
					runValidators(values[fieldName], field.validate, values) ||
					ownErrors[fieldName];

				newErrors[fieldName] = error;
				if (error && typeof error === 'object') {
					validForm =
						validForm &&
						Object.keys(error).reduce(
							(accumulator, currentValue) => accumulator && error[currentValue],
							true,
						);
				} else {
					validForm = validForm && !error;
				}
			}
		});
		setErrors({
			...errors,
			...newErrors
		});

		return validForm;
	};

	const validateField = (fieldName, value = values[fieldName]) => {
		const field = props.validationSchema[fieldName];
		const error = runValidators(value, field.validate, values) || ownErrors[fieldName];

		setErrors({
			...errors,
			[fieldName]: error
		});
	};

	const buildHandleSubmit = (options = {}) => (e) => {
		const isFormValid = validateForm();

		if (!isFormValid) {
			return;
		}

		return props.onSubmit({
			...values,
			...options
		});
	};

	return props.children({
		values,
		errors,
		onChange,
		updateValue,
		onError,
		buildHandleSubmit,
		onBlur,
		resetErrors,
		validateForm,
		validateField,
		setValues
	});
};

Form.defaultProps = {
	validationSchema: {}
};

Form.propTypes = {
	initialValues: PropTypes.object,
	validationSchema: PropTypes.object,
	onSubmit: PropTypes.func.isRequired,
	children: PropTypes.func.isRequired,
	validateOnBlur: PropTypes.bool,
	validateOnChange: PropTypes.bool
};